<template>
    <div class="subscribe__cover" v-if="value">
        <div class="subscribe__wrap">
            <h1 class="subscribe__title">关注公众号</h1>
            <div class="subscribe-qrcode__wrap">
                <img width="100%" src="../assets/qrcode-kl.jpg" alt="">
            </div>
            <div class="subscribe__tip">
                <p>请关注公众号，关注后才能进入</p>
                <p>长按二维码识别图中二维码关注</p>
            </div>
        </div>
        <button class="submit__btn" @click="onClick">我知道了</button>
    </div>
</template>

<script>
    export default {
        name: "Subscribe",
        props: {
            value: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            onClick() {
                this.$emit('input', !this.value)
            }
        }
    }
</script>

<style scoped lang="scss">
    .subscribe__cover {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.75);
        z-index: 99999;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

    }

    .subscribe__wrap {
        background-color: #fff;
        width: 80%;
        .subscribe__title {
            text-align: center;
            font-size: 0.64rem;
            color: #1f1f1f;
            padding: 0.53rem 0;
        }

        .subscribe-qrcode__wrap {
            width: 67.5%;
            padding: 0.53rem;
            margin: 0 auto;
            border: 1px solid #ccc;
        }
        
        .subscribe__tip {
            font-size: 0.4rem;
            color: #8F8F8F;
            text-align: center;
            margin: 0.43rem 0 0.96rem;
        }
    }

    .submit__btn {
        margin-top: 0.67rem;
        background-color: transparent;
        border: 1px solid #FFA347;
        color: #FFA347;
        outline: 0;
        line-height: 1.07rem;
        height: 1.07rem;
        padding: 0 1.84rem;
        border-radius: 0.6rem;
    }
</style>
